export enum UserEnum {
  ADMIN = 'admin',
  PURCHASING = 'purchasing', //jemand der den Einkauf regelt
  BUYER = 'buyer', //jemand der Kauft
  // SERVICE = 'service', //Service Mitarbeiter
}
